"use client";

import React from "react";
import { FileCheck, Settings, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  title: "Music, Soundtracks & Production",
  description: "Custom music, soundtracks and jingles tailored to your songs, video games, films, videos and more, making your branding and style unforgettable",
  icon: FileCheck
}, {
  title: "Mixing & Mastering",
  description: "For artists, albums, advanced soundscapes and beyond using the latest technologies and techniques for living, breathing production",
  icon: Settings
}, {
  title: "Sound Design & Dialogue Cleanup\xA0",
  description: "Detailed sound design and effects and pristine dialogue for Film, TV & Podcasts. Everything you need for that final professional touch",
  icon: Cpu
}];
export default function SonicSolutions() {
  return <section data-section-id="227957" id="sonic-solutions" className="bg-background text-foreground relative overflow-hidden ![padding:50px_0px_96px_0px]">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-primary mb-4 tracking-tighter">How I can help YOU</h2>
          <p className="text-muted-foreground text-lg font-sans">Whether it's music, composition, sound design, production or even video and tuition, get in touch via the contact form and we'll see what we can do</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative rounded-md p-px overflow-hidden transition-all duration-500 hover:-translate-y-2 shadow-md hover:shadow-3xl">
              {}
              <div className="absolute inset-0 bg-border group-hover:bg-gradient-to-br group-hover:from-secondary group-hover:to-primary transition-all duration-500" />

              {}
              <div className="relative h-full bg-card backdrop-blur-xl rounded-md p-8 flex flex-col items-center text-center z-10">
                <div className="mb-8 p-5 rounded-md bg-background/40 text-secondary group-hover:text-primary group-hover:scale-110 transition-all duration-500 border border-border">
                  <service.icon className="w-12 h-12" strokeWidth={1} />
                </div>

                <h3 className="text-2xl font-bold font-default text-primary mb-4 tracking-tight">
                  {service.title}
                </h3>

                <p className="text-muted-foreground font-sans mb-8 flex-grow leading-relaxed">
                  {service.description}
                </p>

                {}
                <div className="opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                  <Button className="bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground border-none shadow-lg font-mono text-xs uppercase tracking-widest" asChild>
                    <Link to="#start-a-project">Get Started</Link>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}